// extracted by css-extract-rspack-plugin
export default {"container":"CellVariantName_container__AnvUb","text":"CellVariantName_text__8KFnX"};